type EnvName = 'local' | 'development' | 'staging' | 'prod';

const rawEnv = process.env.REACT_APP_ENV;

export const env: EnvName =
  rawEnv === 'staging'     ? 'staging'  :
  rawEnv === 'prod'        ? 'prod'     :
  rawEnv === 'development' ? 'development' :
  'local';

if (rawEnv && !['local', 'development', 'staging', 'prod'].includes(rawEnv)) {
  console.warn(
    `REACT_APP_ENV="${rawEnv}" n'est pas reconnu. ` +
    `Valeurs attendues : "local", "development", "staging" ou "prod". ` +
    `On utilise "local" par défaut.`
  );
}

/*type ConfigType = {
  local:   { baseUrl: string };
  development: { baseUrl: string };
  staging: { baseUrl: string };
  prod:    { baseUrl: string };
};

const config: ConfigType = {
  local:   { baseUrl: "http://localhost:8080" },
  development: { baseUrl: "https://tsapp-dev.sylq.io"},
  staging: { baseUrl: "https://tsapp-stg.sylq.io" },
  prod:    { baseUrl: "https://tsapp.tmp.sylq.io" },
};

export const baseUrl = config[env].baseUrl;*/

export const baseUrl = process.env.REACT_APP_BASE_URL;

if (!baseUrl) {
  console.warn(
    `La variable REACT_APP_BASE_URL n'est pas définie. ` +
    `Vérifie ton build-arg Docker ou ton .env file.`
  );
}
